/* Kit cart validation: blocks checkout while any kit line is invalid */
(function () {
  let timer = null;

  function check() {
    const kitLines = document.querySelectorAll('[data-kit-line]');
    const invalid = Array.from(kitLines).filter((el) => el.dataset.kitInvalid === 'true');
    kitLines.forEach((el) => {
      const item = el.closest('.cart__item');
      if (item) item.classList.toggle('cart__item--kit-invalid', el.dataset.kitInvalid === 'true');
    });
    const blocked = invalid.length > 0;
    const message = blocked ? invalid[0].dataset.kitBlockedMessage : '';

    // Broadcast also toggles `disabled` on this fieldset (accept-terms flow), so only
    // undo a disable we applied ourselves.
    document.querySelectorAll('[data-cart-checkout-button]').forEach((fieldset) => {
      const owned = fieldset.hasAttribute('data-kit-blocked');
      if (blocked) {
        if (!owned) fieldset.setAttribute('data-kit-blocked', fieldset.disabled ? 'was-disabled' : '');
        fieldset.disabled = true;
      } else if (owned) {
        fieldset.disabled = fieldset.getAttribute('data-kit-blocked') === 'was-disabled';
        fieldset.removeAttribute('data-kit-blocked');
      }
      fieldset.classList.toggle('is-kit-blocked', blocked);
    });
    document.querySelectorAll('[data-cart-checkout-buttons]').forEach((wrap) => {
      let note = wrap.querySelector('[data-kit-checkout-message]');
      if (!blocked) {
        if (note) note.remove();
        return;
      }
      if (!note) {
        note = document.createElement('p');
        note.className = 'cart__kit-message';
        note.setAttribute('data-kit-checkout-message', '');
        wrap.prepend(note);
      }
      if (note.textContent !== message) note.textContent = message;
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 80);
  }

  function observe() {
    const roots = document.querySelectorAll('[data-section-type="cart-drawer"], [data-section-type="cart"]');
    if (!roots.length) return;
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.addedNodes.length || m.removedNodes.length)) schedule();
    });
    roots.forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  }

  ['theme:cart:change', 'theme:cart:refresh', 'theme:cart:toggle', 'theme:product:added'].forEach((name) =>
    document.addEventListener(name, schedule)
  );
  // The accept-terms checkbox handler re-enables the fieldset; re-assert after it runs.
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-acceptance-checkbox]')) schedule();
  });
  ['click', 'submit'].forEach((name) =>
    document.addEventListener(
      name,
      (event) => {
        if (event.target.closest && event.target.closest('.is-kit-blocked')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    )
  );
  const init = () => {
    observe();
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
